import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import GatsbyIcon from "../images/Gatsby-Monogram.svg"
import ContentfulIcon from "../images/Contentful-Monogram.svg"
import TailwindIcon from "../images/tailwindcss-icon.svg"

export default function Credits() {
    return(
        <div className="flex bg-offwhite h-4 justify-end items-center gap-x-1 mr-2">
            <span className="text-sm font-dokdo">Built with</span>
            <Link to="https://www.gatsbyjs.com" target="blank">
                <img 
                    src={GatsbyIcon}
                    width={12}
                />
            </Link>
            <Link to="https://www.contentful.com" target="blank">
                <img 
                    src={ContentfulIcon}
                    width={16}
                />
            </Link>
            <Link to="https://www.tailwindcss.com" target="blank">
                <img 
                    src={TailwindIcon}
                    width={12}
                />
            </Link>
        </div>
    )    
}